import MarketplaceFeatures from "./Marketplace/MarketplaceFeatures.vue";
import MarketplacePartners from "./Marketplace/MarketplacePartners.vue";
import CarbucksRewards from "./ConsumerProposition/CarbucksRewards.vue";
import CarbucksProtect from "./ConsumerProposition/CarbucksProtect.vue";
import CarbucksProtectCategories from "./ConsumerProposition/CarbucksProtectCategories.vue";
import Carparc from "./DealerProposition/Carparc.vue";
import RewardsSummary from "./DealerProposition/RewardsSummary.vue";
import ProtectSummary from "./DealerProposition/ProtectSummary.vue";
import EarlySignUpOffer from "./DealerProposition/EarlySignUpOffer.vue";
import CarbucksPullupBanners from "./PointOfSale/CarbucksPullupBanners.vue";
import CarbucksRewardsFlyer from "./PointOfSale/CarbucksRewardsFlyer.vue";
import CarbucksRewardsWindowHangar from "./PointOfSale/CarbucksRewardsWindowHangar.vue";
import CarbucksProtectBrochure from "./PointOfSale/CarbucksProtectBrochure.vue";
import HealthMonitoring from "./WhatIsCarbucks/HealthMonitoring.vue";
import TheCarbucksApp from "./WhatIsCarbucks/TheCarbucksApp.vue";
import Dashboard from "./WhatIsCarbucks/Dashboard.vue";
import Concierge from "./WhatIsCarbucks/Concierge.vue";
import Marketplace from "./WhatIsCarbucks/Marketplace.vue";
import PutItAllTogether from "./WhatIsCarbucks/PutItAllTogether.vue";
import TermsAndConditions from "./TermsAndConditions/TermsAndConditions.vue"; 
import Suttons from "./CaseStudy/Suttons.vue";
import SuttonsInfoGraphic from "./CaseStudy/SuttonsInfoGraphic.vue";
import Demo from "./Demo/Demo.vue";
import DmsIntegration from "./DmsIntegration/DmsIntegration.vue";
import DealerCashback from "./DealerCashback/DealerCashback.vue";

export const useSharedSlides = () => [

    // Marketplace
    { 
        name: 'marketplace', 
        title: 'The Carbucks Marketplace',
        displayPageTitle: true,
        isAppendix: false,
        hasTitlePage: true,
        pages: [
            { component: MarketplaceFeatures },
            { component: MarketplacePartners }
        ],
        images: [
            '/Marketplace/marketplace-triangle-nodes.png',
            '/Marketplace/marketplace-triangle-arrows-1.png',
            '/Marketplace/marketplace-triangle-arrows-2.png',
            '/Marketplace/marketplace-triangle-arrows-3.png',
            '/Marketplace/marketplace-triangle-phone-1.png',
            '/Marketplace/marketplace-triangle-phone-2.png',
            '/Marketplace/dan-murphey.png',
            '/Marketplace/choice.png',
            '/Marketplace/big-w.png',
            '/Marketplace/bws.png',
            '/Marketplace/virgin.png',
            '/Marketplace/freely.png',
            '/Marketplace/booking.png',
            '/Marketplace/omio.png',
            '/Marketplace/adidas.png',
            '/Marketplace/pay-by-card.jpg',
            '/Marketplace/visa.png',
            '/Marketplace/mastercard.png',
            '/Marketplace/eftpos.png',
            '/Marketplace/google-pay.png',
            '/Marketplace/samsung-pay.png',
            '/Marketplace/apple-pay.png',
        ]   
    },

    // Consumer Proposition
    { 
        name: 'consumer-proposition', 
        title: 'Consumer Proposition',
        displayPageTitle: true,
        isAppendix: false,
        hasTitlePage: true,
        pages: [
            { component: CarbucksRewards, title: 'Real Benefits, Long-Term Retention' },
            { component: CarbucksProtect, title: 'Upfront Revenue & Retention' },
            { component: CarbucksProtectCategories, title: 'Great Benefits, Great Margins' }
        ],
        images: [
            '/ConsumerProposition/carbucks-rewards-logo.png',
            '/ConsumerProposition/carbucks-protect-logo.png',
        ]   
    },

    // Dealer Proposition
    { 
        name: 'dealer-proposition', 
        title: 'Dealer Proposition',
        displayPageTitle: true,
        isAppendix: false,
        hasTitlePage: true,
        pages: [
            { component: Carparc },
            { component: RewardsSummary, title: 'Carbucks REWARDS Summary' },
            { component: ProtectSummary, title: 'New Upfront Revenue' },
            { component: EarlySignUpOffer }
        ],
        images: [
            '/DealerProposition/early-bird-discount-smooth.png',
            '/DealerProposition/carbucks-dashboard-logo.png',
            '/background-overlay-4.jpg',
        ]   
    },

    // Point of Sale
    { 
        name: 'point-of-sale', 
        title: 'Point of Sale',
        displayPageTitle: true,
        isAppendix: true,
        hasTitlePage: true,
        pages: [
            { component: CarbucksRewardsFlyer, title: 'Carbucks REWARDS Flyer' },
            { component: CarbucksRewardsWindowHangar, title: 'Carbucks REWARDS Window Hangar' },
            { component: CarbucksProtectBrochure, title: 'Carbucks PROTECT Brochure' },
            { component: CarbucksPullupBanners, title: 'Pull-up Banners' },
        ],
        images: [
            '/PointOfSale/rewards-flyer.png',
            '/PointOfSale/rewards-window-hangar.png',
            '/PointOfSale/rewards-pullup-banner.png',
            '/PointOfSale/protect-pullup-banner.png',
            '/PointOfSale/protect-brochure.png',
        ]   
    },

    // What is Carbucks
    { 
        name: 'what-is-carbucks', 
        title: 'What is Carbucks?',
        displayPageTitle: true,
        isAppendix: false,
        hasTitlePage: true,
        pages: [
            { component: TheCarbucksApp },
            { component: HealthMonitoring },
            { component: Concierge },
            { component: Marketplace },
            { component: Dashboard },
            { component: PutItAllTogether, title: 'Put it all together' }
        ],
        images: [
            '/WhatIsCarbucks/product-overview.png',
            '/WhatIsCarbucks/health-monitoring.png',
            '/WhatIsCarbucks/app.png',
            '/WhatIsCarbucks/dashboard.png',
            '/WhatIsCarbucks/concierge.png',
            '/WhatIsCarbucks/marketplace.png',
            '/WhatIsCarbucks/summary-1.png',
            '/WhatIsCarbucks/summary-2.png',
            '/WhatIsCarbucks/carbucks.png',
            '/WhatIsCarbucks/careplan.png',
            '/WhatIsCarbucks/carbucks-protect.png'
        ]   
    },

    // Terms and Conditions
    { 
        name: 'terms-and-conditions', 
        title: 'Terms and Conditions',
        displayPageTitle: true,
        isAppendix: true,
        hasTitlePage: false,
        pages: [
            { component: TermsAndConditions }
        ],
        images: [
            '/TermsAndConditions/consumer-toc.png',
            '/TermsAndConditions/dealer-toc.png',
        ]   
    },

    // Case Study
    { 
        name: 'case-study', 
        title: 'Case Study',
        displayPageTitle: true,
        isAppendix: true,
        hasTitlePage: false,
        pages: [
            { component: SuttonsInfoGraphic },
            { component: Suttons }
        ],
        images: [
            '/CaseStudy/info-graphic.jpg',
            '/CaseStudy/bridgette-noun.jpg',
        ]   
    },
    
    // Dealer Cashback
    { 
        name: 'dealer-cashback', 
        title: 'Dealer Cashback',
        displayPageTitle: true,
        isAppendix: true,
        hasTitlePage: false,
        pages: [
            { component: DealerCashback }
        ],
        images: [
            '/DealerCashback/dealer-cashback.jpg'
        ]   
    },

    // Demo
    { 
        name: 'demo', 
        title: 'Product Demo',
        displayPageTitle: true,
        isAppendix: false,
        hasTitlePage: false,
        pages: [
            { component: Demo }
        ],
        images: [
            '/Demo/carbucks.png',
            '/Demo/carparc.png',
        ]   
    },
    
    // DMS Integration
    { 
        name: 'dms-integration', 
        title: 'DMS Integration',
        displayPageTitle: true,
        isAppendix: true,
        hasTitlePage: false,
        pages: [
            { component: DmsIntegration }
        ],
        images: [
            '/background-overlay-5.jpg',
        ]   
    },

];
